import React from 'react';
import { useLocation } from 'react-router-dom';

import Message from "../components/Message";

const ErrorPage = () => {
    const location = useLocation();
    const { returning = false, missing_patient = false, zocdoc = false, photos = false, portal = false, appointment = false } = location.state || {};

    const getNextPath = () => {
        if (zocdoc) return "/zocdoc";
        if (returning) return "/returning";
        if (photos) return "/upload-photos";
        if (portal) return "/login";
        if (appointment) return "/appointment-booking";
        return "/";
    };

    return (
        <Message
            returning={returning}
            title={"Oops, looks like something went wrong."}
            subtitle={
                missing_patient
                    ? "We just need to confirm a few details since your last visit."
                    : "Please click below to resubmit your information. If this keeps happening text or call us at 781-650-4492."
            }
            next={getNextPath()}
            nextTitle={missing_patient ? "Let's go" : "Fix this now"}
            selected={true}
        />
    );
};

export default ErrorPage;
